import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Level from '../level';

import './levels-filter-bar.css';

class LevelsFilterBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedLevel: null
    };
  }

  _getOnLevelSelected(level) {
    return () => {
      if (this.state.selectedLevel === level) {
        level = null;
      }

      this.setState({
        selectedLevel: level
      });

      this.props.onSelect(level);
    }
  }

  render() {
    const levels = [ 1, 2, 3 ];

    return (
      <div className='levels-filter-bar'>
        {
          levels.map((level) => 
            <div key={`levels-filter-bar-level-${level}`} className={ ( this.state.selectedLevel === null || this.state.selectedLevel === level) ? 'level selected' : 'level'}>
              <Level level={level} onClick={this._getOnLevelSelected(level)} />
            </div>            
          )
        }
      </div>
    );
  }
}

LevelsFilterBar.propTypes = {
  onSelect: PropTypes.func.isRequired
}

export default LevelsFilterBar;